import React, { useState } from "react";
import { useQuery } from "react-query";
import { Card, Select, Typography, Spin, Empty } from "antd";
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getContractsTimeline } from "../../../services/dashboard.service";
import moment from "moment";

const { Title } = Typography;
const { Option } = Select;

export default function ContractsTimeline() {
  const [months, setMonths] = useState(12);
  const { data, isLoading } = useQuery(
    ["getContractsTimeline", months],
    () => getContractsTimeline(months),
    {
      refetchOnWindowFocus: false,
    }
  );

  const chartData = data?.data || [];

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Title level={5} style={{ margin: 0 }}>
              Planos Contratados
            </Title>
            <Typography.Text type="secondary">
              Últimos {months} meses
            </Typography.Text>
          </div>
          <Select
            defaultValue={12}
            style={{ width: 120 }}
            onChange={(value) => setMonths(value)}
          >
            <Option value={6}>6 meses</Option>
            <Option value={12}>12 meses</Option>
            <Option value={24}>24 meses</Option>
          </Select>
        </div>
      }
      bordered={false}
      style={{ height: "100%" }}
    >
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
          <Spin />
        </div>
      ) : chartData.length > 0 ? (
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <ComposedChart
              data={chartData}
              margin={{
                top: 20,
                right: 20,
                bottom: 20,
                left: 20,
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis
                dataKey="month"
                scale="band"
                tickFormatter={(value: any) =>
                  `${moment(value).format("MM/YYYY")}`
                }
              />
              <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
              <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" />
              <Tooltip
                labelFormatter={(value: any) =>
                  `${moment(value).format("MM/YYYY")}`
                }
              />
              <Legend />
              <Bar
                yAxisId="left"
                dataKey="new_contracts"
                name="Contratações"
                barSize={20}
                fill="#413ea0"
              />
              <Bar
                yAxisId="left"
                dataKey="inactivated"
                name="Inativações"
                barSize={20}
                fill="#ff7300"
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="active_total"
                name="Planos Contratados Ativos"
                stroke="#ff7300"
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <Empty description="Sem dados para o período" />
      )}
    </Card>
  );
}
